import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Home from './pages/Home';
import VisualNovel from './pages/VisualNovel';
import CompanionList from './pages/CompanionList';
import Threads from './pages/Threads';
import Chat from './pages/Chat';
import CallPage from './pages/CallPage';
import CreateCompanion from './pages/CreateCompanion';
import Settings from './pages/Settings';
import ChatSettings from './pages/ChatSettings';
import SecurityLog from './pages/SecurityLog';
import Journal from './pages/Journal';
import ThreadSummary from './pages/ThreadSummary';
import Feed from './pages/Feed';
import Library from './pages/Library';
import Stats from './pages/Stats';
import Study from './pages/Study';
import StudySettings from './pages/StudySettings';
import StudyStats from './pages/StudyStats';
import Keepsakes from './pages/Keepsakes';
import Novels from './pages/Novels';
import NovelDetail from './pages/NovelDetail';
import NovelNotes from './pages/NovelNotes';
import ChapterEditor from './pages/ChapterEditor';
import ToDo from './pages/ToDo';
import VideoHome from './pages/VideoHome';
import VideoLibrary from './pages/VideoLibrary';
import HomeSettings from './pages/HomeSettings';
import Spending from './pages/Spending';
import Writing from './pages/Writing';
import WritingNew from './pages/WritingNew';
import WritingBook from './pages/WritingBook';
import WritingRoom from './pages/WritingRoom';
import WritingBible from './pages/WritingBible';
import Fanfiction from './pages/Fanfiction';
import FanficDetail from './pages/FanficDetail';
import Vault from './pages/Vault';
import CalebNotes from './pages/CalebNotes';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Navigate to="/" replace />} />

        {/* HOME */}
        <Route path="/companions" element={<ProtectedRoute><Home /></ProtectedRoute>} />

        {/* ACCOUNT */}
        <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
        <Route path="/security" element={<ProtectedRoute><SecurityLog /></ProtectedRoute>} />
        <Route path="/settings/home" element={<ProtectedRoute><HomeSettings /></ProtectedRoute>} />
        <Route path="/settings/spending" element={<ProtectedRoute><Spending /></ProtectedRoute>} />

        {/* COMPANIONS */}
        <Route path="/companions/list" element={<ProtectedRoute><CompanionList /></ProtectedRoute>} />
        <Route path="/companions/new" element={<ProtectedRoute><CreateCompanion /></ProtectedRoute>} />
        <Route path="/threads/:companionId" element={<ProtectedRoute><Threads /></ProtectedRoute>} />
        <Route path="/chat/:companionId/:threadId" element={<ProtectedRoute><Chat /></ProtectedRoute>} />
        <Route path="/chat-settings/:companionId" element={<ProtectedRoute><ChatSettings /></ProtectedRoute>} />
        <Route path="/journal/:companionId" element={<ProtectedRoute><Journal /></ProtectedRoute>} />
        <Route path="/memory/:companionId/:threadId" element={<ProtectedRoute><ThreadSummary /></ProtectedRoute>} />
        <Route path="/feed/:companionId" element={<ProtectedRoute><Feed /></ProtectedRoute>} />
        <Route path="/library/:companionId" element={<ProtectedRoute><Library /></ProtectedRoute>} />
        <Route path="/stats/:companionId" element={<ProtectedRoute><Stats /></ProtectedRoute>} />

        {/* PHONE CALLS */}
        <Route path="/call/:companionId" element={<ProtectedRoute><CallPage /></ProtectedRoute>} />

        {/* NOVELS */}
        <Route path="/novels" element={<ProtectedRoute><Novels /></ProtectedRoute>} />
        <Route path="/novels/:id" element={<ProtectedRoute><NovelDetail /></ProtectedRoute>} />
        <Route path="/novels/:id/notes" element={<ProtectedRoute><NovelNotes /></ProtectedRoute>} />
        <Route path="/novels/:id/chapters/:chapterId" element={<ProtectedRoute><ChapterEditor /></ProtectedRoute>} />

        {/* STUDY */}
        <Route path="/study" element={<ProtectedRoute><Study /></ProtectedRoute>} />
        <Route path="/study/settings" element={<ProtectedRoute><StudySettings /></ProtectedRoute>} />
        <Route path="/study/stats" element={<ProtectedRoute><StudyStats /></ProtectedRoute>} />
        <Route path="/study/keepsakes" element={<ProtectedRoute><Keepsakes /></ProtectedRoute>} />

        {/* PUPPY & PIPSQUEAK VISUAL NOVEL */}
        <Route path="/visual-novel" element={<ProtectedRoute><VisualNovel /></ProtectedRoute>} />

        {/* TO-DO */}
        <Route path="/todos" element={<ProtectedRoute><ToDo /></ProtectedRoute>} />

        {/* VIDEO */}
        <Route path="/video" element={<ProtectedRoute><VideoHome /></ProtectedRoute>} />
        <Route path="/video/library" element={<ProtectedRoute><VideoLibrary /></ProtectedRoute>} />

        {/* writing room */}
        <Route path="/writing" element={<ProtectedRoute><Writing /></ProtectedRoute>} />
        <Route path="/writing/new" element={<ProtectedRoute><WritingNew /></ProtectedRoute>} />
        <Route path="/writing/book/:bookId" element={<ProtectedRoute><WritingBook /></ProtectedRoute>} />
        <Route path="/writing/p/:pieceId" element={<ProtectedRoute><WritingRoom /></ProtectedRoute>} />
        <Route path="/writing/bible/:workId" element={<ProtectedRoute><WritingBible /></ProtectedRoute>} />

        {/* Fanfiction & vault */}
        <Route path="/fanfiction" element={<ProtectedRoute><Fanfiction /></ProtectedRoute>} />
        <Route path="/fanfiction/:id" element={<ProtectedRoute><FanficDetail /></ProtectedRoute>} />
        <Route path="/vault" element={<ProtectedRoute><Vault /></ProtectedRoute>} />
        <Route path="/notes" element={<ProtectedRoute><CalebNotes /></ProtectedRoute>} />

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
